import React from "react";

const GROUPS = [0, 90, 180, 270];
// Outer rays are short, inner rays long — the traditional Zia proportions.
const RAYS = [
  { offset: -13.5, length: 12 },
  { offset: -4.5, length: 19 },
  { offset: 4.5, length: 19 },
  { offset: 13.5, length: 12 },
];

type Props = {
  size?: number | string;
  className?: string;
};

/** The New Mexico Zia sun, used as the shop's divider mark. */
export const Zia = ({ size = 24, className }: Props) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M50 34a16 16 0 1 0 0 32 16 16 0 0 0 0-32Zm0 8a8 8 0 1 1 0 16 8 8 0 0 1 0-16Z" />
    {GROUPS.map((angle) => (
      <g key={angle} transform={`rotate(${angle} 50 50)`}>
        {RAYS.map(({ offset, length }) => (
          <rect
            key={offset}
            x={50 + offset - 3}
            y={28 - length}
            width={6}
            height={length}
            rx={1}
          />
        ))}
      </g>
    ))}
  </svg>
);
